var exports = {
  "KF": "UserVoiceTab.module__sliderLabel___N2toLV",
  "Gl": "UserVoiceTab.module__sliderLabelRow___N2toLV",
  "Qg": "UserVoiceTab.module__audioProcessing___N2toLV",
  "Om": "UserVoiceTab.module__audioProcessingCard___N2toLV",
  "ZT": "UserVoiceTab.module__deviceNotice___N2toLV",
  "ei": "UserVoiceTab.module__deviceNoticeText___N2toLV",
  "dv": "UserVoiceTab.module__deviceNoticeTitle___N2toLV",
  "H6": "UserVoiceTab.module__deviceNoticeDescription___N2toLV",
  "Ov": "UserVoiceTab.module__pttSettings___N2toLV",
  "jS": "UserVoiceTab.module__pttSettingRow___N2toLV",
  "ps": "UserVoiceTab.module__pttSettingDescription___N2toLV",
  "Np": "UserVoiceTab.module__profileSubSection___N2toLV",
  "aG": "UserVoiceTab.module__sensitivitySliderWrapper___N2toLV",
};

module.exports = exports;
